import axios from "axios";

// Retrieve base URL from env
const BASE_URL = process.env.REACT_APP_MONGOAPI_BASE_URL;




// Axios instance
const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: "application/json",
  },
});
let logoutFn = null;

export const setLogoutHandler = (fn) => {
  logoutFn = fn;
};


// Request interceptor → add JWT token if exists
apiClient.interceptors.request.use(
  (config) => {
    console.log("===== REQUEST INTERCEPTOR =====");
    console.log("Method:", config.method);
    console.log("URL:", config.baseURL + config.url);

    const token = localStorage.getItem("jwt_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const isFormData =
      typeof FormData !== "undefined" && config.data instanceof FormData;

    if (isFormData) {
      // Let axios/browser set multipart/form-data WITH boundary
      delete config.headers["Content-Type"];
      if (config.headers.common) delete config.headers.common["Content-Type"];
      if (config.headers.post) delete config.headers.post["Content-Type"];
      if (config.headers.put) delete config.headers.put["Content-Type"];
      if (config.headers.patch) delete config.headers.patch["Content-Type"];
    } else {
      config.headers["Content-Type"] = "application/json";
    }

    console.log("Content-Type going out:", config.headers["Content-Type"]);
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor → enforce status 200
apiClient.interceptors.response.use(
  (response) => {
    // Accept all successful HTTP responses (200–299)
    if (response.status < 200 || response.status >= 300) {
      throw new Error(
        `API Error: ${response.status} ${response.statusText}`
      );
    }

    return response.data;
  },
  (error) => {
    if (error.response?.status === 401) {
      if (logoutFn) logoutFn();   // <-- call logout from context
      return Promise.reject(new Error("Session expired. Please login again."));
    }
    if (error.response) {
      throw new Error(
        `API Error: ${error.response.status} ${error.response.data?.message || error.response.statusText}`
      );
    } else if (error.request) {
      throw new Error("API Error: No response from server");
    } else {
      throw new Error(`API Error: ${error.message}`);
    }
  }
);

// Common API method
export async function callMongoApi(method, endpoint, data = {}, config = {}) {
  try {
    method = method.toUpperCase();

    switch (method) {
      case "GET":
          console.log("===== GET API =====");
          console.log("Base URL:", BASE_URL);
          console.log("Endpoint:", endpoint);
          console.log("Full URL:", `${BASE_URL}${endpoint}`);
          console.log("Params:", data);
        return await apiClient.get(endpoint, { params: data, ...config });

      case "POST":
        return await apiClient.post(endpoint, data, config);

      case "PUT":
        return await apiClient.put(endpoint, data, config);

      case "DELETE":
        return await apiClient.delete(endpoint, { ...config });

      default:
        throw new Error(`Unsupported method: ${method}`);
    }
  } catch (error) {
      console.log("===== API ERROR =====");
      console.log("Message:", error.message);
      console.log("Response:", error.response);
      console.log("Request:", error.request);
      console.log("Full Error:", error);
    
    throw error;
  }
}
// ------------------ Help Desk: Comments & Replies ------------------

export async function getComments(requestId) {
  return await callMongoApi("GET", `/help-requests/${requestId}/comments`);
}

export async function addComment(requestId, text) {
  return await callMongoApi("POST", `/help-requests/${requestId}/comments`, {
    text,
  });
}

export async function replyToComment(requestId, commentId, text) {
  return await callMongoApi(
    "POST",
    `/help-requests/${requestId}/comments/${commentId}/replies`,
    { text, isInternal: true }
  );
}
export async function updateComment(requestId, commentId, text) {
  return await callMongoApi(
    "PUT",
    `/help-requests/${requestId}/comments/${commentId}`,
    { text }
  );
}
